export function unixtimeNow() {
  return Math.floor(Date.now() / 1000);
}

export function unixtimeAdd(seconds) {
  return Math.floor(Date.now() / 1000) + seconds;
}

export function fromUnixtime(unixTimestamp) {
  if (!!unixTimestamp) {
    const d = new Date(unixTimestamp * 1000);
    return dateAndTime(d);
  } else {
    return null;
  }
}

export function fromIso(isoDate) {
  if (!!isoDate) {
    const d = new Date(isoDate);
    return dateAndTime(d);
  } else {
    return null;
  }
}

export function fromIsoOnlyDate(isoDate) {
  if (!!isoDate) {
    const d = new Date(isoDate);
    return dateOnly(d);
  } else {
    return null;
  }
}

function dateAndTime(d) {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const date = d.getDate();
  const year = d.getFullYear();
  const month = months[d.getMonth()];
  const hour = d.getHours();
  const min = d.getMinutes();
  const sec = d.getSeconds();

  return `${date < 10 ? `0${date}` : date}-${month}-${year} ${
    hour < 10 ? (hour === 0 ? "00" : `0${hour}`) : hour
  }:${min < 10 ? (min === 0 ? "00" : `0${min}`) : min}:${
    sec < 10 ? (sec === 0 ? "00" : `0${sec}`) : sec
  }`;
}

function dateOnly(d) {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const date = d.getDate();
  const year = d.getFullYear();
  const month = months[d.getMonth()];

  return `${date < 10 ? `0${date}` : date}-${month}-${year}`;
}
